import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { RxSerieDialogComponent } from 'src/app/dialogs/contact/rx-serie-dialog/rx-serie-dialog.component';
import { LaboDialogComponent } from 'src/app/dialogs/labo/labo-dialog/labo-dialog.component';
import { CNConsultation } from 'src/app/models/cnconsultation';
import { CNContactRXSerie } from 'src/app/models/cncontactrxserie';
import { PatientService } from 'src/app/services/patient.service';
import { RxSerie2DialogComponent } from '../../../../dialogs/contact/rx-serie-2-dialog/rx-serie-2-dialog.component';

@Component({
  selector: 'app-contact-rx-serie',
  templateUrl: './contact-rx-serie.component.html',
  styleUrls: ['./contact-rx-serie.component.scss']
})
export class ContactRxSerieComponent implements OnInit {

  private theContact: CNConsultation;
  public rxSeries: CNContactRXSerie[] = [];

  constructor(private dialog: MatDialog, private patient: PatientService) { }

  ngOnInit(): void {
  }

  @Input() set contact(theContact) {
    this.theContact = theContact;
    if (this.theContact && this.theContact.getProperty('StVaast_Type') === 'RX') {
      this.rxSeries = this.theContact.childs$('SNItem.CNItem.CNContactRXSerie') as CNContactRXSerie[];
    }
  }

  public openSerie(serie: CNContactRXSerie) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
        serie,
        patient: this.patient.patient,
        contact: this.theContact
    };
    dialogConfig.panelClass = 'rx-viewer-dialog';
    dialogConfig.width = '80vw';
    dialogConfig.maxWidth = '80vw';
    dialogConfig.height = '80vh';
    const dialogRef = this.dialog.open(RxSerie2DialogComponent, dialogConfig);
  }
}
